export default "__VITE_ASSET__D$uMyVqj__"